import React from 'react'
import PropTypes from 'prop-types'

import Dropdown from '../Dropdown'
import splitComponentProps from '../../utils/splitComponentProps'

/* eslint-disable */
const propTypes = {
  ...Dropdown.propTypes,

  // Toggle props.
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  title: PropTypes.node.isRequired,
  noCaret: PropTypes.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: PropTypes.node
}

class DropdownButton extends React.Component {
  render() {
    const { bsSize, bsStyle, title, children, ...props } = this.props

    const [dropdownProps, toggleProps] = splitComponentProps(
      props,
      Dropdown.ControlledComponent
    )

    return (
      <Dropdown {...dropdownProps} bsSize={bsSize} bsStyle={bsStyle}>
        <Dropdown.Toggle {...toggleProps} bsSize={bsSize} bsStyle={bsStyle}>
          {title}
        </Dropdown.Toggle>

        <Dropdown.Menu>{children}</Dropdown.Menu>
      </Dropdown>
    )
  }
}

DropdownButton.propTypes = propTypes

export default DropdownButton



// WEBPACK FOOTER //
// ./components/DropdownButton/index.jsx